export const vimeoUrlPattern = /vimeo/;

export function isVimeoVideoUrl(url: string) {
  return url.match(vimeoUrlPattern);
}
